import { render, staticRenderFns } from "./ListItemDetail.vue?vue&type=template&id=50701a01&scoped=true&"
import script from "./ListItemDetail.vue?vue&type=script&lang=js&"
export * from "./ListItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50701a01",
  null
  
)

export default component.exports